module.exports = __webpack_public_path__ + "assets/images/profiles/2020-1-desktop.jpg?v=488c2b14";